/** @jsxRuntime classic */

/** @jsx jsx */
import { jsx } from '@emotion/core';
import Rodal from 'rodal';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'emotion-theming';
import { home, migratoryWebCitizen, phytosanitaryWeb, sanitarianRegistersWeb, tdCarWeb } from '../../Colors';
import useMediaQuery from '../../../hooks/use-media-query';
import { ExclamationTriangleIcon } from '../../../icon';
import { Button } from '../../../core';
import { DivRow, DivColumn } from '../InputsUI';
import SpinnerSmall from '../../SpinnerSmall';
import styles from './modalStyle';
import modalCustomStyle from './utils';
const themes = {
  home: {
    alpha: home.cerulean,
    beta: home.prussianBlue,
    gamma: home.cerulean,
    delta: home.fireEngineRed,
    epsilon: home.white
  },
  migratoryWebCitizen: {
    alpha: migratoryWebCitizen.cerulean,
    beta: migratoryWebCitizen.prussianBlue,
    gamma: migratoryWebCitizen.cerulean,
    delta: migratoryWebCitizen.fireEngineRed,
    epsilon: migratoryWebCitizen.white
  },
  sanitarianRegistersWeb: {
    alpha: sanitarianRegistersWeb.cerulean,
    beta: sanitarianRegistersWeb.prussianBlue,
    gamma: sanitarianRegistersWeb.deepCerulean,
    delta: sanitarianRegistersWeb.fireEngineRed,
    epsilon: sanitarianRegistersWeb.white
  },
  phytosanitaryWeb: {
    alpha: phytosanitaryWeb.lightSeaGreen,
    beta: phytosanitaryWeb.allports,
    gamma: phytosanitaryWeb.mantis,
    delta: phytosanitaryWeb.mantis,
    epsilon: phytosanitaryWeb.sherpaBlue
  },
  tdCarWeb: {
    alpha: tdCarWeb.cerulean,
    beta: tdCarWeb.prussianBlue,
    gamma: tdCarWeb.cerulean,
    delta: tdCarWeb.fireEngineRed,
    epsilon: tdCarWeb.white
  }
};
/**
 * This component represents a modal for cancel a procedure.
 * @param {boolean} isVisible Determines if the modal is visible or not.
 * @param {function} setIsVisible Function triggered when close the modal to hide it.
 * @param {function} proceedToCancel Cancel the procedure.
 * @param {string} isCanceling Determine if it is in the process of cancellation.
 */

export default function CancelProcedureWarning({
  isVisible,
  setIsVisible,
  proceedToCancel,
  isCanceling
}) {
  const {
    theme
  } = useTheme();
  const {
    t
  } = useTranslation();
  const {
    isMobile
  } = useMediaQuery();
  return jsx(Rodal, {
    visible: isVisible,
    showCloseButton: false,
    width: 781,
    height: 255,
    closeOnEsc: true,
    onClose: () => {},
    customStyles: (modalCustomStyle({
      isMobile,
      width: 781,
      height: 255
    }), {
      borderRadius: 10
    })
  }, jsx("div", {
    css: [styles, {
      paddingTop: 48
    }]
  }, jsx(DivRow, {
    className: "modals-row"
  }, jsx(DivColumn, {
    className: "modals-column"
  }, jsx(ExclamationTriangleIcon, {
    className: "icon",
    css: {
      color: themes[theme].alpha
    }
  })), jsx(DivColumn, {
    className: "modals-column"
  }, jsx("h1", {
    className: "modals-title",
    style: {
      color: themes[theme].beta
    }
  }, t('Cancelar este trámite')), jsx("p", {
    className: "modals-description"
  }, t('Una vez cancelado no podrá editarlo ni enviarlo a revisión ¿Está seguro que desea continuar?')))), jsx("div", {
    className: "button-container"
  }, jsx(Button, {
    size: "md-icon",
    outline: true,
    className: "button blue",
    style: {
      color: themes[theme].gamma,
      border: `2px solid ${themes[theme].gamma}`,
      width: 150
    },
    disabled: isCanceling,
    onClick: setIsVisible
  }, t('Salir')), jsx(Button, {
    size: "md-icon",
    className: "button red",
    style: {
      background: themes[theme].delta,
      color: themes[theme].epsilon
    },
    disabled: isCanceling,
    onClick: proceedToCancel
  }, t('Cancelar trámite'), isCanceling ? jsx(SpinnerSmall, {
    className: "spinner"
  }) : ''))));
}